module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/soc_4-d5584e29e70c472e434771e63f21609a.svg";